import React, {useState} from 'react';
import {pathOr} from 'ramda';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {compose} from 'redux';
import {connect} from 'react-redux';
import moment from 'moment';

import css from './styles.css';
import {PrimaryButton} from '../Button/Button';
import {
  createBoostersProductCheckoutSession,
} from '../../ducks/ownListings.duck';
import BuyBoostersPanelModal from './BuyBoostersPanelModal/BuyBoostersPanelModal';
import {helpCenterUrl} from "../../marketplace-custom-config";

const BoostYourListings = ({
                             intl,
                             onCreateBoostersProductCheckoutSession,
                             fetchBoostersCheckoutSessionInProgress,
                             fetchBoostersCheckoutSessionError,
                             boostedLimitAt,
                             numberOfBoosters,
                             isLight
                           }) => {
  const [isOpenBoostersPanelModal, setIsOpenBoostersPanelModal] = useState(false);
  const handleOpenBoostersPanel = () => {
    setIsOpenBoostersPanelModal(true);
  }

  return (
    <div>
      <div className={css.container}>
        <BuyBoostersPanelModal
          isOpen={isOpenBoostersPanelModal}
          intl={intl}
          onCreateBoostersProductCheckoutSession={onCreateBoostersProductCheckoutSession}
          fetchBoostersCheckoutSessionInProgress={fetchBoostersCheckoutSessionInProgress}
          fetchBoostersCheckoutSessionError={fetchBoostersCheckoutSessionError}
          // inProgress={isAddingToCartInProgress}
          onCloseModal={() => setIsOpenBoostersPanelModal(false)}
          // onSubmit={() => handleSubmitMultiBooking(isMobile, true)}
          onManageDisableScrolling={Function.prototype}
          // listingCover={path(['images', 0, 'attributes', 'variants', 'square-small', 'url'], listing)}
        />
        <div className={!isLight && css.inlineResponsive}>
          <div className={css.inline}>
            <div>
              <div className={css.mainManImg}/>
            </div>
            <div className={css.bodyText}>
              <div className={css.title}>
                <FormattedMessage id="BoostYourListings.title"/>
              </div>
              <div className={css.description}>
                <FormattedMessage id="BoostYourListings.description"/>
              </div>
            </div>
          </div>
          <div className={css.ctaContainer}>
            <PrimaryButton
              onClick={handleOpenBoostersPanel}
            >
              <FormattedMessage id="BoostYourListings.cta"/>
            </PrimaryButton>
          </div>
        </div>
      </div>
      {!isLight && numberOfBoosters > 0 && (
        <div className={css.userResume}>
          <FormattedMessage id="BoostYourListings.UserResume" values={{
            numberOfBoosters,
            date: moment(boostedLimitAt).format('DD/MM/YYYY')
          }}/> <a href={`${helpCenterUrl}/sections/17760916715666-Utilisation-des-boosters`} target={'_blank'}><FormattedMessage id="BoostYourListingsQuestion" /></a>
        </div>
      )}
    </div>
  );
};

BoostYourListings.defaultProps = {};

BoostYourListings.propTypes = {};

const mapStateToProps = state => ({
  numberOfBoosters: pathOr(0, ['user', 'currentUser', 'attributes', 'profile', 'metadata', 'numberOfBoosters'], state),
  boostedLimitAt: pathOr(null, ['user', 'currentUser', 'attributes', 'profile', 'metadata', 'boostedLimitAt'], state),
  fetchBoostersCheckoutSessionInProgress: pathOr(false, ['ownListings', 'fetchBoostersCheckoutSessionInProgress'], state),
  fetchBoostersCheckoutSessionError: pathOr(null, ['ownListings', 'fetchBoostersCheckoutSessionError'], state),
});

const mapDispatchToProps = dispatch => ({
  onCreateBoostersProductCheckoutSession: (planId) => dispatch(createBoostersProductCheckoutSession(planId)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
)(BoostYourListings);
